export default __webpack_public_path__ + "static/media/node-js-icon.2879fa18.svg";